import { useCallback, useEffect, useRef, useState } from "react";

import { useSignups } from "Signups/state";

import useEventListener from "Utilities/useEventListener";

/**
 * Lets the PayNow UI scroll, but then stick to the top of the page
 * gets publicHeaderHeight from SignupHeader
 */
export default function useIsPayNowSticky(amount) {
  const [state] = useSignups();
  const [isSticky, setIsSticky] = useState(false);
  const publicHeaderHeight = state.publicHeaderHeight;
  const ref = useRef();

  const determineStickiness = useCallback(() => {
    const elOffset = ref?.current?.offsetTop;
    const windowOffset = window.scrollY;

    if (windowOffset > elOffset - 30 && windowOffset > publicHeaderHeight) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  }, [publicHeaderHeight]);

  useEventListener("scroll", determineStickiness);

  useEffect(() => {
    determineStickiness();
  }, [amount, determineStickiness]);

  return { isSticky, ref };
}
